import * as React from 'react';
import RoutePrivate from '../router/RoutePrivate';
import PersonnelPage from './pages/PersonnelPage';
import LandmanDetailPage from './pages/LandmanDetailPage';
import ManageRatesPage from './pages/ManageRatesPage';
// import Tax1099Page from './pages/1099Page';
import PaperworkAccessPage from './pages/PaperworkAccessPage';
import ContractPayPage from './pages/ContractPayPage';
import BillingPage from './pages/BillingPage';
import EmployeePayPage from './pages/EmployeePayPage';
import ScorecardPage from './pages/ScorecardPage';
import ManageContactInfoPageFF from './pages/ManageContactInfoPage';
import ManageCommentsPage from './pages/ManageCommentsPage';

export default function getRoutes(isLoggedIn: boolean) {
    return [
        <RoutePrivate key="personnel" path="/personnel/home" component={PersonnelPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate exact={true} key="personnel" path="/personnel/:id/home" component={PersonnelPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="paperwork" path="/personnel/paperwork" component={PaperworkAccessPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate exact={true} key="benefits" path="/personnel/:id/paperwork" component={PaperworkAccessPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="scorecard" path="/personnel/scorecard" component={ScorecardPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate exact={true} key="scorecard" path="/personnel/:id/scorecard" component={ScorecardPage} isLoggedIn={isLoggedIn} />,
        // <RoutePrivate key="1099" path="/personnel/1099" component={Tax1099Page} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="contract-pay" path="/personnel/contract-pay" component={ContractPayPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate exact={true} key="contract-pay" path="/personnel/:id/contract-pay" component={ContractPayPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="billing" path="/personnel/billing" component={BillingPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate exact={true} key="billing" path="/personnel/:id/billing" component={BillingPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="employee-pay" path="/personnel/employee-pay" component={EmployeePayPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate exact={true} key="employee-pay" path="/personnel/:id/employee-pay" component={EmployeePayPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate
            key="landman-manage-contact-info"
            path="/landmen/:id/manage-contact-info"
            component={ManageContactInfoPageFF}
            isLoggedIn={isLoggedIn}
        />,
        <RoutePrivate exact={true} key="landman-manage-rates" path="/landmen/:id/manage-rates" component={ManageRatesPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate exact={true} key="landman-detail" path="/landmen/:id" component={LandmanDetailPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate
            exact={true}
            key="landman-manage-comments"
            path="/landmen/:id/manage-comments"
            component={ManageCommentsPage}
            isLoggedIn={isLoggedIn}
        />,
    ];
}



// WEBPACK FOOTER //
// ./src/components/personnel/Personnel.Routes.tsx